module.exports = __webpack_public_path__ + "img/cmg-labs-4.5c48ec9a.jpg";